<div class="portal-shell min-h-screen">
  <a class="portal-skip" href="#portal-content" (click)="$event.preventDefault(); content.focus()">Saltar al contenido</a>
  <app-sidenav></app-sidenav>

  <div class="portal-workspace min-h-screen flex flex-col">
    <header class="portal-header sticky top-0 z-30">
      <div class="portal-header__inner px-4 sm:px-6 py-4 flex items-center justify-between gap-4">
        <div class="min-w-0">
          <h1 class="portal-title">
            {{ pageTitle }}
          </h1>
          <p *ngIf="pageSubtitle" class="portal-subtitle">
            {{ pageSubtitle }}
          </p>
        </div>

        <div class="flex items-center gap-2">
          <a
            routerLink="/usuarios"
            class="portal-user inline-flex items-center gap-2 cursor-pointer"
            title="Ver y editar perfil de usuario"
            [attr.aria-label]="'Ver perfil de ' + userLabel"
          >
            <span class="material-icons text-[18px]" aria-hidden="true">person</span>
            <span class="portal-user__label">{{ userLabel }}</span>
          </a>
        </div>
      </div>
    </header>

    <main #content id="portal-content" class="flex-1 app-page" tabindex="-1">
      <router-outlet></router-outlet>
    </main>
  </div>
</div>

<ngx-spinner
  [name]="spinnerName"
  bdColor="rgba(243, 244, 245, 0.55)"
  class="app-loading-spinner"
  aria-label="Cargando"
  role="status"
  aria-live="polite"
  template="<img class='app-loading-spinner__image' src='assets/loader/healthfinder-tres-puntos.svg' width='160' height='160' alt='' aria-hidden='true'>">
</ngx-spinner>
